import { useCallback } from "react"
import { useLocation } from "react-router-dom"
import { config } from "~/config"

/**
 * カスタムURLスキームでアプリを起動し、失敗時にdeeplink踏み台経由へフォールバックするハンドラーを返す。
 *
 * 挙動:
 * 1. カスタムURLスキーム（popopo://）でアプリを起動しようとする
 * 2. 50ms後もページに留まっていたら（アプリが開かなかった）、deeplink踏み台経由にフォールバック
 * 3. ページが非表示になった場合（アプリが開いた）はフォールバックをキャンセル
 *
 * TODO: このフォールバック処理は下位互換性のための暫定実装。
 *       不要になったらカスタムスキーム試行を削除し、直接 fallbackUrl（deeplink踏み台経由）を開くこと。
 */
export function useOpenAppHandler(): () => void {
  const location = useLocation()
  return useCallback(() => {
    const schemeUrl = `${config.appOpenUrl}${location.pathname.slice(1)}${location.search}`
    const fallbackUrl = `${config.applinkBaseUrl}${location.pathname}${location.search}`

    window.location.href = schemeUrl

    const timeout = setTimeout(() => {
      window.location.href = fallbackUrl
    }, 50)

    const onVisibilityChange = () => {
      if (document.hidden) {
        clearTimeout(timeout)
      }
      document.removeEventListener("visibilitychange", onVisibilityChange)
    }
    document.addEventListener("visibilitychange", onVisibilityChange)
  }, [location.pathname, location.search])
}
